import { render, staticRenderFns } from "./RulesView.vue?vue&type=template&id=3abbacc3&scoped=true"
var script = {}
import style0 from "./RulesView.vue?vue&type=style&index=0&id=3abbacc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abbacc3",
  null
  
)

export default component.exports